export const toChartTime = (timestamp: number, timezoneOffset: number): number => timestamp - timezoneOffset * 60000;
